import { useId } from 'react';
import type { Team } from '../types';
import { useI18n } from '../i18n';

export default function TeamGenderSelect({ value, onChange, disabled = false, unsetLabel, showOptionsInLabel = false }: {
  value: Team['gender'];
  onChange: (value: Team['gender']) => void;
  disabled?: boolean;
  unsetLabel?: string;
  showOptionsInLabel?: boolean;
}) {
  const id = useId();
  const { t } = useI18n();
  return <div>
    <label htmlFor={id} className="mb-1 block text-sm font-medium text-gray-700">{t('team_gender_label')}{showOptionsInLabel && <span className="font-normal text-gray-500"> ({[t('team_gender_male'), t('team_gender_female'), t('team_gender_mixed'), unsetLabel ?? t('team_gender_unset')].join(' / ')})</span>}</label>
    <select id={id} value={value || ''} disabled={disabled}
      onChange={event => onChange((event.target.value || null) as Team['gender'])}
      className="min-h-11 w-full rounded-lg border border-gray-300 bg-white px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500">
      <option value="">{unsetLabel ?? t('team_gender_unset')}</option>
      {(['male', 'female', 'mixed'] as const).map(gender => <option key={gender} value={gender}>{t(`team_gender_${gender}`)}</option>)}
    </select>
  </div>;
}
